import { render } from "./App.vue?vue&type=template&id=3dc2a67a"
const script = {}

import "./App.vue?vue&type=style&index=0&id=3dc2a67a&lang=css"

import exportComponent from "/Users/long/Development/ge_vue/node_modules/.pnpm/registry.npmmirror.com+vue-loader@17.0.1_vue@3.2.47+webpack@5.75.0/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__